module.exports = __webpack_public_path__ + "static/media/admin.ac4f28c0.jpg";